import { ref } from 'vue'
import api from '@/services/api'
import { useWorkspaceStaffAccess } from '@/composables/useWorkspaceStaffAccess'

export function useAgendamentoStaffDelete(workspaceIdRef, onDeleted) {
  const { canStaffManage, loadStaffRole } = useWorkspaceStaffAccess(workspaceIdRef)

  const confirmDeleteTarget = ref(null)
  const deleting = ref(false)

  const canDeleteAgendamento = canStaffManage

  function requestDeleteAgendamento(agendamento) {
    confirmDeleteTarget.value = agendamento
  }

  function cancelDeleteAgendamento() {
    if (deleting.value) return
    confirmDeleteTarget.value = null
  }

  async function confirmDeleteAgendamento() {
    const target = confirmDeleteTarget.value
    if (!target?.id || deleting.value) return
    deleting.value = true
    try {
      await api.delete(`/agendamentos/cliente/agendamento/${target.id}`)
      confirmDeleteTarget.value = null
      await onDeleted?.()
    } catch (error) {
      console.error('Erro ao excluir agendamento:', error)
    } finally {
      deleting.value = false
    }
  }

  return {
    canDeleteAgendamento,
    confirmDeleteTarget,
    deleting,
    loadStaffRole,
    requestDeleteAgendamento,
    cancelDeleteAgendamento,
    confirmDeleteAgendamento
  }
}
